if (typeof window.isNaN !== 'function') {
  window.isNaN = function (value) {
    if (typeof value !== 'number') {
      return true
    }
    return value !== value
  }
}
if (!Number.isNaN || typeof Number.isNaN !== 'function') {
  Number.isNaN = function (value) {
    return window.isNaN(value)
  }
}
